import type { FaireProductEntity } from "../../entity_types/product";

export const p_ng86adtb4j: FaireProductEntity = {
  token: "p_ng86adtb4j",
  type: "product",
  name: "Nesquik Chocolate Wafer Bars (28g) (24ct)",
  brandToken: "b_5fqs9qr72c",
  brandName: "Pops Distro Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/9347f97ab42193c7439aa7772c0bbdaca7d63e6790a23314599564de0bd39578.jpeg",
  galleryImageUrls: [],
  priceDollars: 51,
  description:
    "\nLooking to tap into nostalgia while delivering a universally loved snack? Our Nesquik Chocolate Wafer Bars 24ct is a surefire hit. With the rich, creamy taste of Nesquik chocolate enveloping crunchy wafer layers, this treat is a profitable addition for retailers, cafes, and snack vendors.\n\n * 🍫 Nostalgic Brand: Nesquik’s iconic taste is a proven seller. \n * 🍪 Wafer & Chocolate Combo: A snack that satisfies multiple cravings. \n * 📦 Bulk Pack: 24-count boxes perfect for maximizing retail space. \n\n***Please note: Chocolate is sensitive to heat. If you're ordering from a location with a hot climate—particularly between May 15th and October 15th—we strongly recommend reaching out before placing your order to request special shipping or insulation options.\n\nOrders shipped without a request for special packing during this period will be sent at the buyer’s own risk, and we cannot guarantee that the chocolate will arrive in perfect condition.",
  tags: [],
  msrpDollars: 102,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:03.129Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
